










































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ToolBar from "@/components/ToolBar.vue";
import DatePicker from "@/components/DatePicker.vue";
import app from "@/store/app";
import AnalyticsApi from "@/utils/api/analytics";
import moment from "moment";

import { formatTextToNumber, trimText } from "@/utils/format";

@Component({
  components: { ToolBar, DatePicker }
})
export default class DataDetails extends Vue {
  public items: Array<string> = ["Active Links", "Advertisers"];
  public startDate = moment()
    .subtract(7, "days")
    .format("YYYY-MM-DD");
  public endDate = moment().format("YYYY-MM-DD");
  public selected_performer: string = this.items[0];
  public topLinks: TopLinks[] = [];
  public topAdvertisers: TopAdvertisers[] = [];
  public displayData: TopAdvertisers[] | TopLinks[] = [];
  public page_count = 1;
  public total_count: number;
  public page = 1;
  public last_id = 0;

  get title() {
    return "數據詳情";
  }

  public formatText(text: string) {
    return trimText(text);
  }

  public formatTextToNumber(text: string) {
    return formatTextToNumber(text);
  }

  @Watch("selected_performer")
  public onSelectedPerformerChange(value: string, oldValue: string) {
    if (value == oldValue) return;
    this.page = 1;
    this.last_id = 0;
    if (value == "Active Links") this.getTopPerformingLinks();
    else this.getTopPerformingAdvertisers();
  }

  @Watch("page")
  public onPageChange(value: number, oldValue: number) {
    if (value === oldValue) return;
    let diff;
    if (value > oldValue) {
      diff = value - oldValue;
      this.last_id += 10 * diff;
    } else if (value < oldValue) {
      diff = oldValue - value;
      this.last_id -= 10 * diff;
    }

    this.getData();
  }

  public listItemStyle(index: number) {
    return index % 2 !== 0 && { background: "#ececec" };
  }

  public updateStartDate(date: string) {
    this.startDate = date;
  }

  public updateEndDate(date: string) {
    this.endDate = date;
  }

  public async mounted() {
    this.getTopPerformingLinks();
  }

  public onNext() {
    this.last_id += 10;
    this.getData();
  }

  public onPrevious() {
    this.last_id -= 10;
    this.getData();
  }

  public getData() {
    if (this.selected_performer == "Active Links") this.getTopPerformingLinks();
    else this.getTopPerformingAdvertisers();
  }

  public async getTopPerformingLinks() {
    try {
      app.SET_IS_LOADING(true);
      const response = await AnalyticsApi.getTopPerformingLinks(
        this.startDate,
        this.endDate,
        this.last_id
      );
      this.displayData = response.data.top_links;
      this.page_count = response.data.pagination.page_count;
      this.total_count = response.data.pagination.total_count;
      this.last_id = Number(response.meta.last_id);
      app.SET_IS_LOADING(false);
    } catch (error) {
      if (error.response.status === 401) {
        window.alert("因帳號權限原因，你目前無法查看此頁面內容");
      }
    }
  }

  public async getTopPerformingAdvertisers() {
    try {
      app.SET_IS_LOADING(true);
      const response = await AnalyticsApi.getTopPerformingAdvertisers(
        this.startDate,
        this.endDate,
        this.last_id
      );
      this.displayData = response.data.top_advertisers;
      this.page_count = response.data.pagination.page_count;
      this.total_count = response.data.pagination.total_count;
      this.last_id = Number(response.meta.last_id);
      app.SET_IS_LOADING(false);
    } catch (error) {
      if (error.response.status === 401) {
        window.alert("因帳號權限原因，你目前無法查看此頁面內容");
      }
    }
  }
}
